<nav class="nav-menu-horizontal">
    <div class="menu-header">
        <!-- Botón hamburguesa para móviles -->
        <button class="mobile-menu-toggle" (click)="toggleMobileMenu()" [class.open]="isMobileMenuOpen">
            <span class="hamburger-line"></span>
            <span class="hamburger-line"></span>
            <span class="hamburger-line"></span>
        </button>
        <div class="menu-label">MENU</div>
        <img class="club-logo" src="assets/images/CLUB_MPA_RGB_NEGRO-01.png" alt="Club MPA">
        <div class="menu-header-actions">
            <!-- Home visible en móvil -->
            <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="menu-link-home"
                style="display: none;">
                <svg class="icono-casa" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 40 L50 10 L90 40" fill="none" stroke="#000" stroke-width="9" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M20 40 V80 H80 V40" fill="none" stroke="#000" stroke-width="9" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <circle cx="50" cy="50" r="10" fill="#000" stroke-width="9" />
                </svg>
            </a>

        </div>
    </div>

    <ul class="menu-list" [class.mobile-open]="isMobileMenuOpen">
        <!-- Home visible en desktop -->
        <li class="menu-item menu-item-home desktop-only">
            <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                class="menu-link-home">
                <svg class="icono-casa" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 40 L50 10 L90 40" fill="none" stroke="#000" stroke-width="9" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M20 40 V80 H80 V40" fill="none" stroke="#000" stroke-width="9" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <circle cx="50" cy="50" r="10" fill="#000" stroke-width="9" />
                </svg>
            </a>
        </li>
        <li *ngFor="let item of navbar; trackBy: trackByItem" class="menu-item">
            <a *ngIf="(!item.Submenu || item.Submenu.length === 0) && item.Route && item.Route !== ''"
                [routerLink]="item.Route" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                class="menu-link" [matTooltip]="item.Tooltip || ''" [matTooltipDisabled]="!item.Tooltip">
                {{ item.Title }}
            </a>

            <span *ngIf="(!item.Submenu || item.Submenu.length === 0) && (!item.Route || item.Route === '')"
                class="menu-link menu-link-noroute" [matTooltip]="item.Tooltip || ''"
                [matTooltipDisabled]="!item.Tooltip">
                {{ item.Title }}
            </span>

            <div *ngIf="item.Submenu && item.Submenu.length > 0" class="menu-dropdown" routerLinkActive="parent-active"
                [routerLinkActiveOptions]="{exact: false}" [class.mobile-expanded]="isMobileSubmenuExpanded(item)">
                <span class="menu-link menu-link-with-submenu" (click)="toggleMobileSubmenu(item)">
                    {{ item.Title }}
                    <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
                </span>
                <ul class="dropdown-list" [class.mobile-show]="isMobileSubmenuExpanded(item)">

                    <li *ngFor="let child of item.Submenu; trackBy: trackByItem" class="dropdown-item">
                        <a *ngIf="child.Route && child.Route !== ''" [routerLink]="child.Route"
                            (click)="onNavigate(child.Route)"
                            routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="dropdown-link"
                            [matTooltip]="child.Tooltip || ''" [matTooltipDisabled]="!child.Tooltip">
                            {{ child.Title }}
                        </a>
                        <span *ngIf="!child.Route || child.Route === ''" class="dropdown-link dropdown-link-noroute"
                            [matTooltip]="child.Tooltip || ''" [matTooltipDisabled]="!child.Tooltip">
                            {{ child.Title }}
                        </span>
                    </li>
                </ul>
            </div>
        </li>
    </ul>
</nav>